import { __spreadArray } from './__helpers/tslib/tslib.es6.js';
import EventsListeners from './EventsListeners.js';

var Events = /** @class */ (function () {
    function Events() {
        this.events = new EventsListeners();
    }
    /**
     * Add new callback to the given event
     * This method is alias to addEventListener
     *
     */
    Events.prototype.on = function (event, callback) {
        return this.addEventListener(event, callback);
    };
    /**
     * Add event listener
     *
     * @param string|array event
     */
    Events.prototype.addEventListener = function (event, callback) {
        if (event.includes(" ")) {
            var subscriptions = [];
            for (var _i = 0, _a = event.split(" "); _i < _a.length; _i++) {
                var eventName = _a[_i];
                subscriptions.push(this.subscribe(eventName, callback));
            }
            return subscriptions;
        }
        else {
            return this.subscribe(event, callback);
        }
    };
    /**
     * Subscribe to the given event
     */
    Events.prototype.subscribe = function (event, callback) {
        var eventHandler = this.events.get(event) || [];
        var subscription = {
            callback: callback,
            event: event,
            dispatch: function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return callback.apply(void 0, args);
            },
            unsubscribe: function () {
                var index = eventHandler.indexOf(subscription);
                if (index !== -1) {
                    eventHandler.splice(index, 1);
                }
            },
        };
        eventHandler.push(subscription);
        this.events.set(event, eventHandler);
        return subscription;
    };
    /**
     * Trigger the given event
     *
     */
    Events.prototype.trigger = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (event.includes(" ")) {
            var events_2 = event.split(" ");
            var returns = {};
            for (var _a = 0, events_1 = events_2; _a < events_1.length; _a++) {
                var event_1 = events_1[_a];
                returns[event_1] = this.trigger.apply(this, __spreadArray([event_1], args, false));
            }
            return returns;
        }
        var callbacks = this.events.get(event);
        if (callbacks.length === 0)
            return;
        var returnValue;
        for (var _b = 0, callbacks_1 = callbacks; _b < callbacks_1.length; _b++) {
            var callback = callbacks_1[_b];
            var callbackReturn = callback.dispatch.apply(callback, args);
            if (callbackReturn === false) {
                return false;
            }
            else if (callbackReturn !== undefined) {
                returnValue = callbackReturn;
            }
        }
        return returnValue;
    };
    /**
     * An alias to trigger method
     */
    Events.prototype.emit = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return this.trigger.apply(this, __spreadArray([event], args, false));
    };
    /**
     * Trigger the event and do not stop on event callback returning false
     *
     * @param {string} event
     * @param  {any[]} args
     * @returns {any[]}
     */
    Events.prototype.triggerAll = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        if (event.includes(" ")) {
            var events_4 = event.split(" ");
            var multipleEvents = [];
            for (var _a = 0, events_3 = events_4; _a < events_3.length; _a++) {
                var event_2 = events_3[_a];
                multipleEvents.push(this.triggerAll.apply(this, __spreadArray([event_2], args, false)));
            }
            return multipleEvents;
        }
        var callbacks = this.events.get(event);
        var returnedOutput = {
            event: event,
            length: 0,
            results: [],
        };
        for (var _b = 0, callbacks_2 = callbacks; _b < callbacks_2.length; _b++) {
            var callback = callbacks_2[_b];
            var callbackReturn = callback.dispatch.apply(callback, args);
            returnedOutput.length++;
            if (callbackReturn !== undefined) {
                returnedOutput.results.push(callbackReturn);
            }
        }
        return returnedOutput;
    };
    /**
     * Alias to off method
     */
    Events.prototype.unsubscribe = function (events) {
        return this.off(events);
    };
    /**
     * This method is used to clear event(s) or remove all events callbacks
     *
     * @param  {string|none} events
     */
    Events.prototype.off = function (events) {
        if (!events) {
            this.events.clear();
            return this;
        }
        var eventsList = events.split(" ");
        for (var _i = 0, eventsList_1 = eventsList; _i < eventsList_1.length; _i++) {
            var event_3 = eventsList_1[_i];
            this.events.delete(event_3);
        }
        return this;
    };
    /**
     * Remove all events that belongs to the given namespace
     *
     * @param   {string} namespace
     * @returns {Events}
     */
    Events.prototype.unsubscribeNamespace = function (namespace) {
        this.events.deleteByNamespace(namespace);
        return this;
    };
    /**
     * List all events by namespace
     *
     * @param {string} namespace
     * @returns {EventListenersList}
     */
    Events.prototype.getByNamespace = function (namespace) {
        return this.events.getByNamespace(namespace);
    };
    /**
     * Get all events listeners by namespace
     *
     * @param {string} namespace
     * @returns {EventSubscription[]}
     */
    Events.prototype.getByNamespaceArray = function (namespace) {
        return this.events.getByNamespaceArray(namespace);
    };
    return Events;
}());
var events = new Events();

export { events as default };
